import { datadogRum } from '@datadog/browser-rum'

import { isRumReady } from './datadogRumBooking.js'

function trackDatadogAction(eventName, eventData) {
  if (typeof datadogRum.addAction !== 'function' || !isRumReady()) {
    return
  }

  datadogRum.addAction(eventName, eventData)
}

export function firstAvailableSelected(eventData) {
  trackDatadogAction('firstAvailableSelected', eventData)
}

export function todaySelected(eventData) {
  trackDatadogAction('todaySelected', eventData)
}

export function nextMonthSelected(eventData) {
  trackDatadogAction('nextMonthSelected', eventData)
}

export function previousMonthSelected(eventData) {
  trackDatadogAction('previousMonthSelected', eventData)
}

export function dateSelected(eventData) {
  trackDatadogAction('dateSelected', eventData)
}

export function timeSelected(eventData) {
  trackDatadogAction('timeSelected', eventData)
}

export function bookingStarted(eventData) {
  trackDatadogAction('bookingIntentStarted', eventData)
}

export function bookingCancelled(eventData) {
  trackDatadogAction('bookingIntentCancelled', eventData)
}

export function bookingFormFieldFilled(eventData) {
  trackDatadogAction('bookingFormFieldFilled', eventData)
}

export function bookingCompleted(eventData) {
  trackDatadogAction('bookingIntentCompleted', eventData)
}

export function requestStarted(eventData) {
  trackDatadogAction('requestIntentStarted', eventData)
}

export function requestCancelled(eventData) {
  trackDatadogAction('requestIntentCancelled', eventData)
}

export function requestCompleted(eventData) {
  trackDatadogAction('requestIntentCompleted', eventData)
}
